import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';
import { FirstServiceInfoResponse } from '@hud/portal-dtos/webapp-service.dto';
import { PORTAL_BASE } from '../consts';

export const FIRST_SERVICE_INFO_ID = 'firstServiceInfo';

export default function useFirstServiceInfo() {
  const { client, isReady } = useClient();

  return useQuery({
    queryKey: [FIRST_SERVICE_INFO_ID],
    queryFn: async () => {
      const response = await client.get<FirstServiceInfoResponse>(
        `${PORTAL_BASE}/first-service-info`
      );

      return FirstServiceInfoResponse.parse(response.data);
    },
    enabled: isReady,
  });
}
